<template>
  <div class="pr-sm-3">
    <div
      class="align-center background-color-white d-flex flex-column py-10 px-7 rounded-lg"
    >
      <div class="font-size-lg font-weight-semibold mb-5 text-center">Contact Us</div>
      <div class="mb-5">
        We hope you're enjoying the convenience <br />
        of ordering online from {{ wait(storeInfo, 'name') }}.
      </div>
      <div class="mb-5 text-center">
        <span class="font-weight-semibold"
          >For questions or issues with your order</span
        >, please contact <br />the store at the phone number: {{
        formatPhoneNumber(wait(storeInfo, 'phone')) }}.
      </div>
      <div class="mb-5 text-center">
        This web store was created by
        <a
          class="font-weight-semibold"
          href="https://nrsplus.com/"
          target="_blank"
          rel="noreferrer"
          >National Retail Solutions, Inc,</a
        ><br />
        a full-service Point of Sale, payments and retail software company.
      </div>
      <div class="mb-5 text-center">
        <span class="font-weight-semibold">For technical support or feedback</span>,
        please <br />contact:
        <a
          class="font-weight-semibold"
          href="mailto:websitesupport@nrsplus.com"
          rel="noreferrer"
          >websitesupport@nrsplus.com</a
        >.
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { formatPhoneNumber, wait } from "@/util.js";

export default {
  name: "SupportDialog",
  computed: {
    ...mapState({
      storeInfo: (state) => state.store.info,
    }),
  },
  methods: {
    formatPhoneNumber,
    wait,
  },
};
</script>
